.initial-sync-ctas > * {
    margin-top: 16px;
    width: 350px;
}
